import { createAndPrintLabel } from './create-and-print-label';
import { createLabel } from './create-label';
import { createTestLabel } from './create-test-label';

export const StandardPrimaryActions = [createAndPrintLabel, createLabel, createTestLabel];
